import { useLastOnline } from "../../utils/formatTime";

const OnOffTime = ({ personalDetail }) => {
  const lastOnlineText = useLastOnline(personalDetail);

  if (personalDetail?.online) {
    return <span>Online</span>;
  }

  return <span>{lastOnlineText}</span>;
};

export { OnOffTime };
